import React, { useEffect, useState } from "react";

// Chakra imports
import {
  Box,
  Button,
  Center,
  Flex,
  Grid,
  Link,
  SimpleGrid,
  Spinner,
  Text,
  useColorModeValue,
  VStack,
} from "@chakra-ui/react";

// Custom components
import Card from "components/card/Card";
import NFT from "components/card/NFT";
import Banner from "views/admin/marketplace/components/Banner";
import HistoryItem from "views/admin/marketplace/components/HistoryItem";
import TableTopCreators from "views/admin/marketplace/components/TableTopCreators";

// Assets
import { apiurl } from "APIURL";
import Avatar1 from "assets/img/avatars/avatar1.png";
import Avatar2 from "assets/img/avatars/avatar2.png";
import Avatar3 from "assets/img/avatars/avatar3.png";
import Avatar4 from "assets/img/avatars/avatar4.png";
import for4 from "assets/img/formations/for4.png";
import for5 from "assets/img/formations/for5.png";
import for6 from "assets/img/formations/for6.png";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { setCurrentFormation } from "redux/slices/currentFormationSlice";
import {
  getEnrolledFormations,
  setEnrolledFormations,
} from "redux/slices/enrolledFormationsSlice";
import { getFormations, setFormations } from "redux/slices/formationsSlice";
import { setGlobalTests } from "redux/slices/testsSlice";
import { getProfileData, setProfile } from "redux/slices/userSlice";
import { Formation } from "types";

export default function Marketplace() {
  const calculateDateDifference = (date1: Date, date2: Date) => {
    const diff = Math.abs(date1.getTime() - date2.getTime());

    const secs = Math.floor(diff / 1000);
    const mins = Math.floor(secs / 60);
    const hours = Math.floor(mins / 60);
    const days = Math.floor(hours / 24);
    if (secs > 60 && mins < 60)
      return (
        mins +
        " minutes et " +
        Math.floor(diff / 1000 - mins * 60) +
        " secondes"
      );
    else if (mins >= 60 && hours < 24)
      return (
        hours +
        " heures et " +
        Math.floor(diff / 60000 - hours * 60) +
        " minutes"
      );
    else if (hours > 24)
      return (
        days +
        " jours et " +
        Math.floor(diff / (60000 * 60) - days * 24) +
        " heures"
      );
    else return secs + " secondes";
  };
  // Chakra Color Mode
  const { formations } = useAppSelector(getFormations);

  const [loadingFormations, setLoadingFormations] = useState(false);
  const enrolledFormations = useAppSelector(
    getEnrolledFormations
  ).enrolledFormations;
  const [bestMembers, setBestMember] = useState<any[]>([]);
  const [historyFormations, setHistoryFormations] = useState<
    {
      title: string;
      description: string;
      image: string;
      price: string | number;
      enrolls: any[];
      addedOn: Date;
      lastModifiedOn: Date;
      id: number;
    }[]
  >([]);
  const [loadingMembers, setLoadingMembers] = useState(false);
  const [loadingHistory, setLoadingHistory] = useState(false);
  const dispatch = useAppDispatch();
  const user = useAppSelector(getProfileData);
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const textColorBrand = useColorModeValue("brand.500", "white");
  const history = useHistory();

  const subscribeFormation = async (
    e: React.MouseEvent,
    formation: Formation
  ) => {
    e.preventDefault();
    if (!enrolledFormations.find((enroll) => enroll.id === formation.id)) {
      const res = await axios.post(`${apiurl}/enroll-in-formation`, {
        userId: user.userId,
        formationId: formation.id,
      });
      console.log(res.data);
    }

    dispatch(setCurrentFormation(formation));

    if (user.roleId != 3) {
      if (enrolledFormations.find((item) => item.id === formation.id)) {
        history.push("/formations/single");
        console.log(history.location);
      } else {
        const res = await axios.post(
          `${apiurl}/payment?amount=${
            user.roleId === 2
              ? formation.stagiarePrice
              : formation.professionalPrice
          }`
        );
        window.open(res.data.payUrl, "_blank");
      }
    } else {
      history.push("/formations/single");
    }
  };

  useEffect(() => {
    const getData = async () => {
      try {
        setLoadingFormations(true);
        const res = await axios.get(`${apiurl}/formation`);
        dispatch(setFormations([...res.data]));
        setLoadingFormations(false);
      } catch (err) {
        console.log(err);
        setLoadingFormations(false);
      }
    };
    getData();
  }, []);
  useEffect(() => {
    const getData = async (userId: string) => {
      try {
        setLoadingFormations(true);
        const res = await axios.get(
          `${apiurl}/enroll-in-formation/enrolledForrmations/${userId}`
        );
        dispatch(setEnrolledFormations([...res.data]));
        setLoadingFormations(false);
      } catch (err) {
        console.log(err);
      }
    };
    getData(user.userId);
  }, [user.userId]);
  useEffect(() => {
    const getBestMembers = async () => {
      try {
        setLoadingMembers(true);
        const res = await axios.get(`${apiurl}/user/allProfiles`);
        console.log(res.data);
        setBestMember(res.data);
        setLoadingMembers(false);
        console.log({ bestMembers });
      } catch (error) {
        console.log(error);
      }
    };
    getBestMembers();
  }, []);
  useEffect(() => {
    const gethistory = async (userId: string) => {
      try {
        setLoadingHistory(true);
        const res = await axios.get(
          `${apiurl}/enroll-in-formation/enrolledForrmations/${userId}`
        );
        console.log(res.data);
        setHistoryFormations(res.data);
        setLoadingHistory(false);
        console.log({ historyFormations });
      } catch (error) {
        console.log(error);
      }
    };
    gethistory(user.userId);
  }, [user.userId]);
  useEffect(() => {
    const getTests = async () => {
      try {
        const res = await axios.get(`${apiurl}/test`);
        dispatch(setGlobalTests([...res.data]));
      } catch (error) {
        console.log(error);
      }
    };
    getTests();
  }, []);
  const token = localStorage.getItem("token");
  React.useEffect(() => {
    const getProfile = async () => {
      const userId = localStorage.getItem("userId");
      const res = await axios.get(`${apiurl}/user/profile/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      localStorage.setItem("role", res.data.user.roleId);
      dispatch(
        setProfile({
          birthdate: new Date(res.data.profile.birthdate),
          ...res.data.profile,
          ...res.data.user,
        })
      );
    };

    getProfile();
  }, [user.id]);
  return (
    <Box pt={{ base: "180px", md: "80px", xl: "80px" }}>
      {/* Main Fields */}
      <Grid
        mb="20px"
        gridTemplateColumns={{ xl: "repeat(3, 1fr)", "2xl": "1fr 0.46fr" }}
        gap={{ base: "20px", xl: "20px" }}
        display={{ base: "block", xl: "grid" }}
      >
        <Flex
          flexDirection="column"
          gridArea={{ xl: "1 / 1 / 2 / 3", "2xl": "1 / 1 / 2 / 2" }}
        >
          <Banner />
          <Flex direction="column">
            <Flex
              mt="45px"
              mb="20px"
              justifyContent="space-between"
              direction={{ base: "column", md: "row" }}
              align={{ base: "start", md: "center" }}
            >
              <Text color={textColor} fontSize="2xl" ms="24px" fontWeight="700">
                Certificats les plus populaires
              </Text>
              <Flex
                align="center"
                me="20px"
                ms={{ base: "24px", md: "0px" }}
                mt={{ base: "20px", md: "0px" }}
              >
                <Link
                  color={textColorBrand}
                  fontWeight="500"
                  me={{ base: "34px", md: "44px" }}
                  href="#art"
                >
                  Réseau
                </Link>
                <Link
                  color={textColorBrand}
                  fontWeight="500"
                  me={{ base: "34px", md: "44px" }}
                  href="#music"
                >
                  Cybersécurité
                </Link>
                <Link
                  color={textColorBrand}
                  fontWeight="500"
                  me={{ base: "34px", md: "44px" }}
                  href="#collectibles"
                >
                  Développement web
                </Link>
                <Link color={textColorBrand} fontWeight="500" href="#sports">
                  Développement mobile
                </Link>
              </Flex>
            </Flex>
            {loadingFormations === true ? (
              <Center>
                <VStack>
                  <Text>Chargement ...</Text>
                  <Spinner />
                </VStack>
              </Center>
            ) : (
              <SimpleGrid columns={{ base: 1, md: 3 }} gap="20px">
                {formations.map((item, index) => (
                  <NFT
                    id={item.id}
                    numOfCandidates={10}
                    name={item.title}
                    author={item.description}
                    bidders={[
                      Avatar1,
                      Avatar2,
                      Avatar3,
                      Avatar4,
                      Avatar1,
                      Avatar1,
                      Avatar1,
                      Avatar1,
                    ]}
                    image={item.image}
                    currentbid={item.stagiarePrice}
                    subscribed={
                      enrolledFormations.find((enroll) => enroll.id === item.id)
                        ? true
                        : false
                    }
                    download="#"
                    onSubscribe={(e) => subscribeFormation(e, item)}
                  />
                ))}
                {/*<NFT
								name='Formations Java Spring Boot'
								author='Formations Java Spring Boot accelèrée'
								bidders={[ Avatar1, Avatar2, Avatar3, Avatar4, Avatar1, Avatar1, Avatar1, Avatar1 ]}
								image={for1}
								currentbid='250 DT'
								download='#'
							/>
							<NFT
								name='Formation ReactJS'
								author='Découvrir comment utiliser React avancée'
								bidders={[ Avatar1, Avatar2, Avatar3, Avatar4, Avatar1, Avatar1, Avatar1, Avatar1 ]}
								image={for2}
								currentbid='350 DT'
								download='#'
							/>
							<NFT
								name='Certificat en Cyber-security'
								author='Formation avancée en Cyber-security linux..'
								bidders={[ Avatar1, Avatar2, Avatar3, Avatar4, Avatar1, Avatar1, Avatar1, Avatar1 ]}
								image={for3}
								currentbid='570 DT'
								download='#'
							/>*/}
              </SimpleGrid>
            )}
            <Text
              mt="45px"
              mb="36px"
              color={textColor}
              fontSize="2xl"
              ms="24px"
              fontWeight="700"
            >
              Recemment ajoute
            </Text>
            <SimpleGrid
              columns={{ base: 1, md: 3 }}
              gap="20px"
              mb={{ base: "20px", xl: "0px" }}
            >
              <NFT
                id={55}
                numOfCandidates={10}
                name="Formation Chaud Froid"
                author="Formation chaud froid et plomberie 80% pratique"
                bidders={[
                  Avatar1,
                  Avatar2,
                  Avatar3,
                  Avatar4,
                  Avatar1,
                  Avatar1,
                  Avatar1,
                  Avatar1,
                ]}
                image={for4}
                currentbid="300 DT"
                download="#"
                onSubscribe={function (): void {
                  throw new Error("Function not implemented.");
                }}
              />
              <NFT
                id={145}
                numOfCandidates={10}
                name="Formation Reseau telecom"
                author="Formations informatique - Réseaux - Télécom "
                bidders={[
                  Avatar1,
                  Avatar2,
                  Avatar3,
                  Avatar4,
                  Avatar1,
                  Avatar1,
                  Avatar1,
                  Avatar1,
                ]}
                image={for5}
                currentbid="500 DT "
                download="#"
                onSubscribe={function (): void {
                  throw new Error("Function not implemented.");
                }}
              />
              <NFT
                id={588}
                numOfCandidates={10}
                name="Formations Sécurité  serveur"
                author="Protection des réseaux énergie publics"
                bidders={[
                  Avatar1,
                  Avatar2,
                  Avatar3,
                  Avatar4,
                  Avatar1,
                  Avatar1,
                  Avatar1,
                  Avatar1,
                ]}
                image={for6}
                currentbid="532 DT"
                download="#"
                onSubscribe={function (): void {
                  throw new Error("Function not implemented.");
                }}
              />
            </SimpleGrid>
          </Flex>
        </Flex>
        <Flex
          flexDirection="column"
          gridArea={{ xl: "1 / 3 / 2 / 4", "2xl": "1 / 2 / 2 / 3" }}
        >
          <Card px="0px" mb="20px">
            {loadingMembers === true ? (
              <Spinner />
            ) : (
              <TableTopCreators
                tableData={
                  bestMembers &&
                  bestMembers.map((item) => {
                    return {
                      name: [item.user.name, item.image, item.status],
                      artworks: item.level,
                      rating: item.rating,
                    };
                  })
                }
              />
            )}
          </Card>
          <Card p="0px">
            <Flex
              align={{ sm: "flex-start", lg: "center" }}
              justify="space-between"
              w="100%"
              px="22px"
              py="18px"
            >
              <Text color={textColor} fontSize="xl" fontWeight="600">
                Historique
              </Text>
              <Button variant="action">Voir tous...</Button>
            </Flex>

            {loadingHistory === true ? (
              <Spinner />
            ) : (
              historyFormations.map((item) => (
                <HistoryItem
                  name={item.title}
                  author={item.description}
                  date={item.enrolls[0].enrollDate}
                  image={item.image}
                  price={item.price}
                />
              ))
            )}
          </Card>
        </Flex>
      </Grid>
      {/* Delete Product */}
    </Box>
  );
}
